/* global localStorage*/
import axios from 'axios'
import store from '../store.js'


export default {
    login: function(username, pass, hash, slug, cb) {
        cb = arguments[arguments.length - 1];
        authenticate(username, pass, hash, slug, (response) => {
            if (response.authenticated) {
                if (cb) cb(response)
            } else {
                if (cb) cb(response)
            }
        })
    },

    getToken: function() {
        return localStorage.sessionId;
    },

    logout: function(cb) {
        delete localStorage.sessionId;
        store.commit('setUserData', {})
        // store.commit('setSlug', null)
        store.commit('setExistingPassword', {})
        store.commit('setLogo', {})
        store.commit('setPackages', {})
        store.commit('setAddress', {})
        store.commit('setPackages', [])
        store.commit('setSharedDocument', {})
    

        if (cb) cb()
    },

    loggedIn: function() {
        return store.state.userInfo.loggedIn
    },
    
    passwordUpdated: function(){
        return !store.state.userInfo.isPasswordChangeNeeded
    },

    resetPassword: function(parameters){
        var args = `{
            "layout" : "WEB_LOG",
            "params" : ${JSON.stringify(parameters)}
        }`
        return axios.post(`resetPassword.php`, args)
        .then((response)=>{
            console.log(response)
            return response.data
        })
        .catch((e)=>{
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
            }
        })
    },

    resetUsername: function(parameters){
        var args = `{
            "layout" : "WEB_LOG",
            "params" : ${JSON.stringify(parameters)}
        }`
        return axios.post(`resetUsername.php`, args)
        .then((response)=>{
            console.log(response)
            return response.data
        })
        .catch((e)=>{
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
            }
        })
    },

    loadLogo: function(slug) {
        // return axios.post(`proxy.php?/layouts/woodburn-unlimited-slug/_find`, query)
     
        return axios.post(`loadLogo.php`, slug)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                // return e.response.data
                return null
            }
            else{
                //Format Unknown Error Like a FM Error
                // return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
                return null
            }
        })
    } ,
    loadAddress: function(slug) {
        // return axios.post(`proxy.php?/layouts/woodburn-unlimited-slug/_find`, query)
     
        return axios.post(`loadAddress.php`, slug)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                // return e.response.data
                return null
            }
            else{
                //Format Unknown Error Like a FM Error
                // return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
                return null
            }
        })
    }

}


function authenticate(username, pass, hash, slug, cb) {
    
    var credentials = `{
        "username" : "${username}",
        "password" : "${pass}",
        "hash" : "${hash}",
        "slug" : "${slug}"
    }`;
    axios.post(`login.php`, credentials)
        .then(response => {
            // success callback
            var expirationDate = new Date();
            expirationDate.setMinutes(expirationDate.getMinutes() + 10);
            response.data.expirationDate = expirationDate;
            if (response.data.loggedIn === true) {
                cb({
                    authenticated: true,
                    user: response.data
                })
            } else {
                cb({
                    authenticated: false,
                    errorMsg: response.data.message
                })
            }
        }, error => {
            // error callback
            console.log(error);
            cb({
                authenticated: false,
                errorMsg: 'Service not available, try again later please.',
                error: error
            })
        });
}